import { ConversationListItem } from "./ConversationListItem";
import { FleetrifyButton } from "../../Button/customButton";
import { fleetrifyIcons } from "../../../assets/icons/icons";
import { MessageSquare, X } from "lucide-react";
import { useGetAllStaffForMessageQuery } from "../../../redux/services/messageApi";
import { useState } from "react";
import { getAvatarColor, getInitials } from "../../../utils/avatar";

const StartConversation = ({
  onBack,
  onSelectDetails,
}: {
  onBack: () => void;
  onSelectDetails: (staff: any) => void;
}) => {
  const [search, setSearch] = useState("");
  const [selectedStaffId, setSelectedStaffId] = useState<string | null>(null);
  const { data: staffResponse, isLoading: staffLoading } =
    useGetAllStaffForMessageQuery(search ? { search } : {});
  const loggedInUserId = localStorage.getItem("userId");

  const staffList = (staffResponse?.data?.data || []).filter(
    (staff: any) => staff.id !== loggedInUserId
  );

  const handleSelect = (staff: any) => {
    setSelectedStaffId(staff.id); // highlight this staff
    onSelectDetails(staff); // emit back to parent
  };
  return (
    <div className=" bg-[#fff] h-full">
      <div className="border-b border-gray-300">
        <div className="flex justify-between items-center bg-[#E7EBF3] p-4">
          <div className="flex gap-3 items-center">
            <MessageSquare className="text-[#143887]" size={20} />
            <h2 className="text-[13px] font-bold text-[#143887]">
              Start Conversation
            </h2>
          </div>
          <X
            className="text-[#143887] cursor-pointer"
            onClick={onBack}
            size={18}
          />
        </div>

        {/* Search Box */}
        <div className="p-4">
          <div className="grid relative mt-4 place-items-center">
            <input
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full text-sm pl-7 py-3 font-medium outline-none placeholder:text-[#828282] placeholder:text-sm rounded-[30px] bg-[#FFFFFF] px-4 border border-gray-300"
            />
            <figure className="absolute right-6">
              {fleetrifyIcons.filterSearchIcon}
            </figure>
          </div>
        </div>
      </div>

      {/* Staff List */}
      <div className="overflow-y-auto p-4">
        {staffLoading && (
          <>
            {Array.from({ length: 4 }).map((_, i) => (
              <ConversationListItem key={`skeleton-${i}`} loading />
            ))}
          </>
        )}

        {!staffLoading && staffList.length === 0 && search && (
          <div className="text-sm text-gray-500">No staff found</div>
        )}

        {staffList.map((staff: any) => {
          const isSelected = staff.id === selectedStaffId;
          return (
            <div
              className={`flex items-center gap-3 cursor-pointer rounded-[16px] my-3 
                ${
                  isSelected
                    ? "p-3 bg-[#E9EFFC] border-l-4 border-[#143887CC]"
                    : "hover:p-3 hover:bg-[#E9EFFC] hover:border-l-4 hover:border-[#143887CC]"
                }`}
              onClick={() => handleSelect(staff)}
            >
              {staff?.profile_image ? (
                <img
                  src={staff.profile_image}
                  alt={staff.name}
                  className="w-[40px] h-[40px] object-cover rounded-full border border-[#143887CC]"
                />
              ) : (
                <div
                  className="w-[40px] h-[40px] rounded-full flex items-center justify-center text-white text-sm font-semibold border border-[#143887CC]"
                  style={{ backgroundColor: getAvatarColor(staff.name) }}
                >
                  {getInitials(staff.name)}
                </div>
              )}
              <div className="text-[14px] text-[#0D160B] font-semibold">
                {staff.name}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StartConversation;
